import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-disclaimer',
  templateUrl: 'admin-disclaimer.template.html',
})
export class AdminDisclaimerComponent implements OnInit, OnDestroy {
  @Input() showPublic: boolean = true;
  @Input() showRequired: boolean = true;

  constructor(private translate: TranslateService) {}

  ngOnInit() {}

  ngOnDestroy() {}
}
